import { injectable } from "@servicetitan/react-ioc";
import { TermsOfUseApi } from "../api/terms-of-use.api";
import { action, makeObservable, observable } from "mobx";
import { EHStore } from "../../common/stores/eh.store";
import DOMPurify from 'dompurify';

@injectable()
export class TermsOfUseStore {
    @observable isLoading = false;
    @observable isError = false;
    @observable isAccepting = false;
    @observable termsOfUse = '';

    constructor(private readonly termsOfUseApi: TermsOfUseApi, private readonly ehStore: EHStore) {
        makeObservable(this);
    }

    @action
    getTermsOfUse = async () => {
        if (this.isLoading || this.isError) {
            return;
        }

        try {
            this.isLoading = true;
            const { data } = await this.termsOfUseApi.getTermsOfUse();
            this.termsOfUse = DOMPurify.sanitize(data);
        } catch (error) {
            console.error(error);
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    }

    @action
    acceptTermsOfUse = async () => {
        try {
            this.isAccepting = true;
            await this.termsOfUseApi.acceptTermsOfUse();
            this.ehStore.isTermsOfUseAccepted = true;
        } catch (error) {
            console.error(error);
        } finally {
            this.isAccepting = false;
        }
    }
}